
import fetchApi from "../fetch-api";
import { getQueryPath } from "../get-query-path";
import { CompaniesIO } from "../company-io";

type CompanyByIdPropsT = {
  date?: string;
  industry?: string;
  limit?: number;
};

export const getUnderClubCompanies = (props: CompanyByIdPropsT) => {
  let params = props;
  const { industry,date } = props;
  const queryPath = getQueryPath({...params});
  return {
    queryKey: ["UNDER_CLUB_COMPANIES", queryPath],
    queryFn: () =>
      fetchApi({
        service:"core-service",
        headers:{method: 'GET'},
        pathname: `/under-club?${ queryPath}`,
        codec: CompaniesIO,
      }),
  };
};
